import ScreenBackground from '@app/domains/common/containers/ScreenBackground';
import type { ClassNameType } from '@app/domains/common/types';
import { findChildByTypeNames } from '@app/domains/common/utils/component';
import clsx from 'clsx';
import type { HTMLAttributes, PropsWithChildren } from 'react';

type Props = HTMLAttributes<HTMLDivElement>;

function DarkBooksLayout({ children }: Props) {
    const [titleChild, contentChild] = findChildByTypeNames(children, [
        'DarkBooksLayoutTitleSection',
        'DarkBooksLayoutContentSection',
    ]);

    return (
        <ScreenBackground className="bg-gray-900">
            <ScreenBackground.BgLayer>
                <Background />
            </ScreenBackground.BgLayer>

            <div className="h-220">{titleChild}</div>
            {contentChild}
        </ScreenBackground>
    );
}

const Background = () => {
    return (
        <div className="h-220 bg-[#111111] bg-[linear-gradient(360deg,#212121e6_0%,#21212100_50%)]">
            <div className="mx-auto h-full max-w-[1080px] bg-[linear-gradient(360deg,#212121e6_0%,#21212100_50%),url('/images/sneakpeek-bg@3x.jpg')] bg-cover bg-center"></div>
        </div>
    );
};

const TitleSection = ({ children, className }: PropsWithChildren<ClassNameType>) => {
    return <section className={clsx('h-full', className)}>{children}</section>;
};

const ContentSection = ({ children }) => {
    return <section>{children}</section>;
};

TitleSection.typeName = 'DarkBooksLayoutTitleSection';
DarkBooksLayout.TitleSection = TitleSection;

ContentSection.typeName = 'DarkBooksLayoutContentSection';
DarkBooksLayout.ContentSection = ContentSection;

export default DarkBooksLayout;
